import { defineStore } from 'pinia'
import { User, UserRights } from '@interfaces/User'

const rightsInit: UserRights = {
  ACCESS_PSAP_RECEVABILITY: false,
  ACCESS_PSAP_RECEVABILITY_SELF: false,
  CONFIRM_PSAP_INITIALIZATION: false,
  MODIFY_HIS_PSAP_INFOS: false,
  MODIFY_OWN: false,
  RECEVABILITY_PSAP_TERMINAL_LOCALISATION_PULL_SVH_TEST: false,
  RECEVABILITY_PSAP_TERMINAL_LOCATION_PULL_TEST: false,
  RECEVABILITY_PSAP_TERMINAL_LOCATION_PUSH_TEST: false,
  RECEVABILITY_PSAP_WAITING_CGU_VALIDATION: false,
  RECEVABILITY_PSAP_WAITING_INFOS_SSL: false,
  VIEW_SVH_ELIGIBILITY: false,
  VIEW_USERS: false,
  EVENTS_MANAGEMENT: false,
  VIEW_USERS_NOT_ADMIN: false,
  VIEW_ALL_PSAP: false,
  VIEW_USERS_MINISTER: false,
  VIEW_USERS_STATE_AUTHORITY: false,
  HNO_MANAGEMENT: false,
  MODIFY_OPERATOR: false,
  VIEW_ALL_OPERATOR: false,
  VIEW_USERS_PSAP_INTEGRATORS: false,
  ACCESS_STATS: false,
  MODIFY_SVH_ELIGIBILITY: false,
  CREATE_USER_MINISTER: false,
  CREATE_USER_PSAP_MANAGER: false,
  ACCESS_OPERATOR_RECEVABILITY: false,
  CREATE_USER_PSAP: false,
  INITIATE_OPERATOR: false,
  CREATE_USER_OPERATOR: false,
  CREATE_USER_PSAP_INTEGRATOR: false,
  CREATE_USER_OPERATOR_MANAGER: false,
  RECEVABILITY_PSAP_AGREEMENT_APNF: false,
  MODIFY_PSAP: false,
  VIEW_PSAP_IN_SERVICE: false,
  INITIATE_PSAP: false,
  VIEW_ATTACHED_PSAP: false,
  MODIFY_OWN_RECEVABILITY: false,
  MODIFY_ATTACHED_PSAP: false,
  DELETE_USERS: false,
  RECEVABILITY_OPERATOR_PUSHLOCATION_TEST_WAITING: false,
  RECEVABILITY_OPERATOR_GETADDRESS_TEST_WAITING: false,
  RECEVABILITY_OPERATOR_GETLOCATIONSVH_TEST_WAITING: false,
  RECEVABILITY_OPERATOR_WAITING_CGU_VALIDATION: false,
  RECEVABILITY_OPERATOR_NOTIFYOPERATOR_TEST_WAITING: false,
  RECEVABILITY_OPERATOR_PUSHLOCATIONSVH_TEST_WAITING: false,
  RECEVABILITY_OPERATOR_VPN_CONFIG_WAITING: false,
  MODIFY_PSAP_THRESHOLD: false,
  CONFIRM_OPERATOR_RECEVABILITY: false,
  RECEVABILITY_OPERATOR_PRESHARED_KEY_WAITING: false,
  RECEVABILITY_PSAP_AGREEMENT_WORLDLINE: false,
  CONFIRM_PSAP_RECEVABILITY: false,
  RECEVABILITY_OPERATOR_WL_VPN_CONFIG_WAITING: false,
  RECEVABILITY_OPERATOR_AGREEMENT_APNF: false,
  RECEVABILITY_OPERATOR_VPN_TEST_WAITING: false,
  CREATE_USER_AUTHORITY_STATE: false,
  RECEVABILITY_PSAP_CONFIG_SSL: false,
  RECEVABILITY_PSAP_AGREEMENT_CPM: false,
  RECEVABILITY_PSAP_GOING_INTO_PRODUCTION: false,
  VIEW_PSAP_OF_MINISTER: false,
  CONSULT_DOCS: false,
  ACCESS_OPERATOR_RECEVABILITY_SELF: false,
  RECEVABILITY_OPERATOR_WL_VPN_TEST_WAITING: false,
  CREATE_USER_ANY: false,
  VIEW_OPERATOR_IN_SERVICE: false,
  CONSULT_WS_LOGS: false,
  VIEW_USERS_OF_PSAP: false,
  MODIFY_HIS_OPERATOR_INFOS: false,
  RECEVABILITY_OPERATOR_AGREEMENT_WORLDLINE: false
}

const useUserStore = defineStore({
  id: 'userStore',
  state: (): User => {
    return {
      authenticated: false,
      blocked: false,
      daysToExpire: 0,
      expired: false,
      login: '',
      name: '',
      rights: rightsInit,
      role: '',
      token: '',
      expiringReminder: 14
    }
  },
  persist: true,
  getters: {
    getUser: (state) => state,
    getToken: (state) => state.token,
    getName: (state) => state.name,
    getExpiringReminder: (state) => state.expiringReminder,
    getRights: (state) => state.rights,
    getRole: (state) => state.role,
    getLogin: (state) => state.login
  },
  actions: {
    setUser(user: User) {
      this.$state = user
      sessionStorage.setItem('userStore', JSON.stringify(this.$state))
    },
    initStore() {
      this.loadUserDetails()
    },
    loadUserDetails() {
      const storedDetails = sessionStorage.getItem('userStore')
      if (storedDetails) {
        const userDetails = JSON.parse(storedDetails)
        Object.assign(this.$state, userDetails)
      }
    },
    deleteUser() {
      this.$reset()
      sessionStorage.removeItem('userStore')
    }
  }
})

export default useUserStore
